import React, { useState } from 'react';
import { useTeachingMode } from '../contexts/TeachingModeContext';
import { BookOpen, GraduationCap, Brain, Settings, ChevronDown } from 'lucide-react';

const TeachingModeSelector = () => {
  const { mode, switchMode } = useTeachingMode();
  const [showModeMenu, setShowModeMenu] = useState(false);

  const modes = [
    {
      id: 'standard',
      name: 'Standard',
      icon: Settings,
      description: 'Full ERP functionality',
      color: 'bg-blue-500'
    },
    {
      id: 'assist',
      name: 'Assist',
      icon: GraduationCap,
      description: 'With teaching aids',
      color: 'bg-green-500'
    },
    {
      id: 'professional',
      name: 'Professional',
      icon: Brain,
      description: 'AI-powered assistance (Coming Soon)',
      color: 'bg-purple-500',
      disabled: true
    }
  ];

  const currentMode = modes.find(m => m.id === mode);
  const CurrentIcon = currentMode?.icon || Settings;

  const handleModeChange = (modeId) => {
    const selectedMode = modes.find(m => m.id === modeId);
    if (!selectedMode?.disabled) {
      switchMode(modeId);
    }
    setShowModeMenu(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setShowModeMenu(!showModeMenu)}
        className="flex items-center space-x-2 px-3 py-2 text-sm text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
        title={currentMode?.description}
      >
        <BookOpen className="w-4 h-4" />
        <span className="hidden sm:inline">Mode:</span>
        <CurrentIcon className="w-4 h-4" />
        <span className="hidden md:inline">{currentMode?.name}</span>
        <ChevronDown className="w-3 h-3" />
      </button>

      {showModeMenu && (
        <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
          <div className="py-2">
            <div className="px-3 py-2 text-xs text-gray-500 border-b border-gray-100">
              Teaching Mode Selection
            </div>
            
            {modes.map((modeOption) => {
              const Icon = modeOption.icon;
              const isActive = mode === modeOption.id;
              const isDisabled = modeOption.disabled;
              
              return (
                <button
                  key={modeOption.id}
                  onClick={() => handleModeChange(modeOption.id)}
                  disabled={isDisabled}
                  className={`w-full px-3 py-2 text-left text-sm hover:bg-gray-50 flex items-center justify-between transition-colors ${
                    isActive 
                      ? 'bg-blue-50 text-blue-600' 
                      : isDisabled
                        ? 'text-gray-400 cursor-not-allowed'
                        : 'text-gray-700 hover:text-gray-900'
                  }`}
                >
                  <div className="flex items-center space-x-2">
                    <Icon className="w-4 h-4" />
                    <div>
                      <span className="font-medium">{modeOption.name}</span>
                      <div className="text-xs text-gray-500">{modeOption.description}</div>
                    </div>
                  </div>
                  <div className="flex items-center space-x-1">
                    {isDisabled && (
                      <span className="text-xs bg-gray-200 text-gray-500 px-2 py-1 rounded">
                        Soon
                      </span>
                    )}
                    {isActive && (
                      <span className="text-blue-600">✓</span>
                    )}
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      )}
      
      {/* Click outside to close menu */}
      {showModeMenu && (
        <div 
          className="fixed inset-0 z-40" 
          onClick={() => setShowModeMenu(false)}
        />
      )}
    </div>
  );
};

export default TeachingModeSelector; 